import React from 'react';

const PricingDetails = () => {
  return(
    <h1 data-testid="pricing-details">
      You can check most of our pricing details <a href="https://www.flowroute.com/pricing-details/" target="_blank" rel="noopener noreferrer">here</a>.
    </h1>
  );
}

export default PricingDetails